import React, { Component, createRef } from "react";
import { withNamespaces } from "react-i18next";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Skeleton from 'react-loading-skeleton';
import { Icon } from "@iconify/react";

// Components
import MobileSubHeader from '../../components/PageHeader/MobileSubHeader';
import Rebate from "./Rebate";
import History from "./History";
import Button from '../../components/Button/Button';
import DateScroller from '../../components/MobileAsset/DateScroller/DateScroller';

export class MobileInstantRebate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterShow: '',
    };
  }

  componentDidMount() {
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  showDateHandler = () => 
  {
    this.setState({
        filterShow: 'date'
    })
  }

  
  toggleHistoryHandler = () => {
    this.setState({
      showHistory: !this.state.showHistory
    });
    if (this.state.showHistory === false) {
        document.body.classList.add('modal-open');
    }
    else {
        document.body.classList.remove('modal-open');
    }
  }

  render() {
    const { t } = this.props;
    const img = this.imageImport(
      require.context(
        "../../assets/images/profile/icons",
        false,
        /\.(png|jpe?g|svg)$/
      )
    );

    return (
      <Auxiliary>
        <DateScroller
            onChangeDateHandler={this.props.onChangeDateHandler}
            toggleShowDateSelect={this.props.toggleShowDateSelect}
            {...this.state}
            {...this.props}
        />
        <MobileSubHeader
          className="bg-white"
          returnPage="/me"
          header={t("instant-rebate.header")}
          modalHeader={t("instant-rebate.history")}
          modalHandler={this.toggleHistoryHandler}
        />
        {this.state.showHistory &&
          <section className="pf-m-dashboard on-top">
            <div className={`filters-m-col ${this.state.filterShow ? 'show' : ''}`}>
                <MobileSubHeader
                  className="bg-white"
                  closeModalHandler={this.toggleHistoryHandler}
                  header={t('instant-rebate.rebate-claim-history')}
                  style={{ justifyContent: "unset" }}
                />
                <div className="filters-m-panel">
                    <div className="filter-m-tp-col">
                        <div className="filter-m-cat">
                            <label className="filter-m-label">{t('history.date')}:</label>
                            <button className={`btn btn-m-filter date ${this.state.filterShow === 'date' && 'active'}`} type="button" onClick={this.showDateHandler}>
                                <p>
                                { this.props.start_date }
                                <br/>
                                { this.props.end_date }
                                </p>
                                <Icon icon="uil:angle-down" />
                            </button>
                        </div>
                    </div>
                    <div className="filter-m-btm-col">
                      <div className={`filters-m-date-group ${this.state.filterShow === 'date' ? 'd-block' : 'd-none'}`}>
                        <div className="d-flex align-items-center flex-wrap">
                            {this.props.filterDate &&
                            this.props.filterDate.map((item, index) => (
                                <div className="form-check form-check-inline filter" key={index}>
                                <input
                                    className="btn-check"
                                    type="radio"
                                    name="filterDate"
                                    id={item.id}
                                    value={item.value}
                                    defaultChecked={index === 0}
                                    checked={index === this.props.currentFilterDate}
                                    onClick={() => this.props.onChangeFilterDateHandler(index)}
                                />
                                <label className="btn form-check-label" htmlFor={item.id} onClick={
                                    () => [
                                    this.props.filterDayRange(item.value)
                                    ]
                                }>
                                    {t(`history.${item.label}`)}
                                </label>
                                </div>
                            ))}
                        </div>
                        <div className="filter-m-date">
                            <label className="filter-m-label">{t("history.start-date")}:</label>
                            <button className="btn btn-m-filter-date" type="button" onClick={(e) => this.props.toggleShowDateSelect(e, 'startDate')}>
                            <p>{this.props.start_date}</p>
                            <Icon icon="uil:angle-right" />
                            </button>
                        </div>
                        <div className="filter-m-date">
                            <label className="filter-m-label">{t("history.end-date")}:</label>
                            <button className="btn btn-m-filter-date" type="button" onClick={(e) => this.props.toggleShowDateSelect(e, 'endDate')}>
                            <p>{this.props.end_date}</p>
                            <Icon icon="uil:angle-right" />
                            </button>
                        </div>
                      </div>
                      {this.state.filterShow &&
                      <>
                          <Button
                              typeButton="button"
                              classValue="btn btn-gradient-blue mt-3"
                              idValue="search"
                              buttonName={t('global.check')}
                              clicked={() => {this.props.searchHandler(this.props.historyTab); this.setState({ filterShow: ''});}}
                              disabled={this.props.disableSearchButton}
                          />       
                          <Button
                            typeButton='button'
                            classValue='btn btn-success w-100'
                            idValue='reset'
                            buttonName={t('global.reset')}
                            clicked={this.props.onResetHandler}
                          />                         
                      </>

                      }
                    </div>
                </div>
            </div>
            <div className="overlay" onClick={() => this.setState({ filterShow: '' })} />
            <div className="m-ir-history-col">
              <History
                {...this.props}
                  tabName="history"
                  datatablesChangeHandler={this.props.datatablesChangeHandler}
              />
            </div>
          </section>
        }
        <section className="m-ir pf-m-dashboard">
          <div className="pd-content">
            <div className="mobile-ir-tp-panel">
              <div className="total-ir-wrapper">
                <div className="total-ir-container">
                  <img className="active" src={img["instant-rebate.svg"]} alt="instant-rebate" />
                  <div>
                    <label>{t("instant-rebate.total-instant-rebate")}</label>
                    <p>
                        {this.state.loading ? (
                            <Skeleton count={1} />
                        ) : (
                          <>
                            <span>
                              <small>MYR</small> {parseFloat(this.props.total_instant_rebate).toFixed(2)}
                            </span>
                          </>
                        )}
                    </p>
                  </div>
                </div>
                  <button type="button" className="btn btn-gradient-blue mt-3" onClick={this.props.handleClaimAll}>
                    {t('instant-rebate.claim-all')}
                  </button>
              </div>
              <p className="p-3"><small>{t("instant-rebate.desc")}</small></p>
            </div>
              <div className="pd-m-card-col">
                <Rebate
                  {...this.props}
                  tabName={'rebate'}
                  datatablesChangeHandler={(val, tab, act) => this.props.datatablesChangeHandler(val, tab, act)}
                  setTotalRebate={this.props.setTotalRebate}
                />
              </div>
          </div>
        </section>
      </Auxiliary>
    )
  }
}

export default (withNamespaces("translation")(MobileInstantRebate));